import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ServerUrlService {
  constructor() { }

  name: string = ''
  url: string = ''
  otimusUrl: string = ''

  clients: any = [{
    name: 'local',
    url: 'http://localhost:9830'
  }];

  getUrl = () => {
    // const url = window.location.pathname.split('/');
    // let baseurl = '';

    // this.clients.map((client) => {
    //   if (client.name == url[1]) {
    //     baseurl = client.url;
    //   }
    // })

    return this.url;
  }

  getName = () => {
    const url = window.location.pathname.split('/');

    return url[1];
  }
}
